module.exports = __webpack_public_path__ + "static/media/picture-outlined-gray.f69899da.svg";